import React from 'react'

import useAxios, { mutate } from 'hooks/useAxios'
import { Button } from 'semantic-ui-react'
import { toast } from 'libs/toast'
import { AllowPermission } from 'shared/components/AllowPermission'
import constants from 'config/constants'

/**
 * @params {object} props
 * @params {string} props.invoiceId
 * @params {string} props.price
 */
export function RetryChargeButton({ invoiceId, price }) {
  const { fetch: retryCharge, loading } = useAxios({
    method: 'POST',
    skip: true,
  })

  function onRetryCharge() {
    retryCharge({ url: `billing/invoices/${invoiceId}/pay/` })
      .then(() => {
        toast.success("Success! You're all paid up.")
        mutate(
          'billing/',
          (state) => {
            const subscription = { ...state.subscription, status: 'active' }
            state.invoices[0].paid = true
            return { ...state, subscription }
          },
          false
        )
        mutate(
          'account/users/me/v2/',
          (state) => {
            const subscription = { ...state.subscription, status: 'active' }
            return { ...state, subscription }
          },
          false
        )
      })
      .catch((e) => {
        const httpStatus = e.response.status
        if (httpStatus >= 400 && httpStatus < 500) {
          toast.error('Payment failed. Please try adding another card or contacting your bank.')
        }
        if (httpStatus >= 500) {
          toast.error('Oops! Something went wrong. Please contact Simplesat support for help.')
        }
        mutate('billing/')
        throw e
      })
  }
  return (
    <AllowPermission permission={constants.permissions.manageBillingInformation}>
      <Button primary onClick={onRetryCharge} disabled={loading} loading={loading}>
        Retry charge of ${parseInt(price)}
      </Button>
    </AllowPermission>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/RetryChargeButton/index.js